var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"opportunity-status-badge",class:{ 'is-dark': _vm.isColorDark, 'is-actionable': _vm.isActionable, 'is-small': _vm.isSmall },style:({ backgroundColor: _vm.color })},[_c('div',{staticClass:"opportunity-status-badge__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }